import store from "../app/store";
/**
 * Requests a pre-signed S3 URL for uploading a PDF file.
 *
 * Sends the PDF file metadata (name, type, size) to the backend,
 * which returns a pre-signed URL and a document key for upload.
 *
 * Endpoint: PUT `/train/uplod_pdf`
 *
 * @async
 * @function UploadPdf
 * @param {File} file - The PDF file to be uploaded (browser File object).
 * @returns {Promise<{
 *   uri: string,     // Pre-signed URL to which the file should be uploaded
 *   error: boolean,  // Whether the request failed
 *   key: string      // Key used to reference the uploaded document later
 * }>}
 *
 * @example
 * const pdfFile = input.files[0];
 * const result = await UploadPdf(pdfFile);
 * if (!result.error) {
 *   await fetch(result.uri, { method: "PUT", body: pdfFile });
 *   console.log("PDF uploaded with key:", result.key);
 * } else {
 *   console.error("Failed to generate upload URL.");
 * }
 */

const UploadPdf = async (file) => {
  const senddata = {
    filename: file.name,
    type: file.type,
    size: file.size,
  };

  console.log("senddata", senddata);

  const domain = process.env.REACT_APP_SERVER;
  const url = `${domain}/train/uplod_pdf`;

  const token = store.getState().auth.token;

  if (!token) {
    return { data: null, error: "No token found" };
  }
  const option = {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(senddata),
  };

  const res = await fetch(url, option);

  if (res.status === 200) {
    const data = await res.json();
    return { uri: data?.url, error: false, key: data?.doc_key };
  } else {
    return { uri: "", error: true, key: "" };
  }
};

export default UploadPdf;
